module.exports = __webpack_public_path__ + "img/gmail.469eae84.svg";